import React, { Component, Fragment } from 'react'
import generatePusher from '../../modules/Pusher'
import isUrl from '../../modules/isUrl'
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  ListGroup,
  ListGroupItem,
  Glyphicon
} from 'react-bootstrap'

class LaunchControl extends Component {
  pusher = generatePusher()
  state = {
    members: [],
    formState: null,
    selectedDevices: [],
  }

  componentDidMount() {
    this.channel = this.pusher.subscribe('presence-urlLauncher')
    this.channel.bind('pusher:subscription_succeeded', (members) => {
      members.each((member) => {
        if (member.id.toString() !== members.me.id.toString()) {
          this.setMemberToState(member)
        }
      })
    })
    this.channel.bind('pusher:member_added', this.setMemberToState)
    this.channel.bind('pusher:member_removed', this.removeMemberFromState)
  }

  componentWillUnmount() {
    if (this.channel) {
      this.pusher.unsubscribe('presence-urlLauncher')
    }
    if (this.feedbackTimeout) {
      clearTimeout(this.feedbackTimeout)
    }
  }

  setMemberToState = (member) => {
    this.setState({
      members: [...this.state.members, member],
    })
  }

  removeMemberFromState = (leavingMember) => {
    this.setState({
      members: this.state.members.filter(member => member.id !== leavingMember.id)
    })
  }

  formToState = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }

  handleSelectedDevice = (id) => {
    this.setState(state => ({
      selectedDevices: state.selectedDevices.includes(id)
        ? state.selectedDevices.filter(deviceId => deviceId !== id)
        : [ ...state.selectedDevices, id]
    }))
  }
 
  launchUrl = () => {
    const { url, selectedDevices } = this.state
    if (!isUrl(url)) {
      this.showFeedback('error')
      return
    }
    
    const channel = this.pusher.subscribe('presence-urlLauncher')
    const pushEvent = channel.trigger('client-launchUrl', {
      launchedDevices: selectedDevices,
      url
    })
    this.showFeedback(pushEvent ? 'success' : 'error')
  }

  showFeedback = (type) => {
    // valid types: 'error', 'success'
    this.setState({
      formState: type,
    })
    this.feedbackTimeout = setTimeout(() => {
      this.setState({
        formState: null,
      })
    }, 3000)
  }

  render() {
    const { members, formState, selectedDevices } = this.state
    return (
      <Fragment>
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h3>URL Launcher</h3>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col md={12}>
              <form>
                <FormGroup validationState={formState}>
                  <ControlLabel>Enter the url you wish to launch on the connected device.</ControlLabel>
                  <FormControl type="text" id="url" placeholder="e.g. http://virginmedia.player.stv.tv" onChange={this.formToState} />
                  <FormControl.Feedback />
                </FormGroup>
                <Button bsStyle="primary" disabled={!Boolean(members.length)}onClick={this.launchUrl}>Launch!</Button>
              </form>
            </Col>
          </Row>
        </Grid>
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h4>Active Devices</h4>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col md={12}>
              <ListGroup>
                {members.map((member, index) => (
                  <ListGroupItem key={index} onClick={() => this.handleSelectedDevice(member.id)} bsStyle={selectedDevices.includes(member.id) ? 'success' : null}>
                    <Glyphicon glyph="signal" className="signal" />
                    <h5 className="active-device">{member.info && member.info.device}</h5>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Col>
          </Row>
        </Grid>
      </Fragment>
    )
  }
}

export default LaunchControl



// WEBPACK FOOTER //
// ./src/routes/launch-control/index.js